export default function SafeReturnIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='none' viewBox='0 0 10 10' {...props}>
      <path
        fill='currentColor'
        d='M5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0Zm1.458 7.083a.417.417 0 0 1 0-.833.625.625 0 0 0 0-1.25H4.167a.104.104 0 0 0-.104.104v.73a.312.312 0 0 1-.534.22l-1.25-1.25a.313.313 0 0 1 0-.442l1.25-1.25a.312.312 0 0 1 .534.221v.73a.104.104 0 0 0 .104.104h2.291a1.458 1.458 0 1 1 0 2.916Z'
      />
    </svg>
  );
}
